/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IEveFormInputViewProps } from './eve-form-input';

export default (props: IEveFormInputViewProps) => {
    if (props.config.istextarea) {
        return (
            <>
                <label className='eve-form__label' htmlFor={props.config.name}>
                    {props.config.friendlyName}
                </label>
                <textarea
                    className='eve-form__text-area'
                    id={props.config.name}
                    name={props.config.name}
                    rows={props.config.rows}
                    maxLength={props.config.characterlimit}
                    onChange={props.handleChange}
                    value={props.registeredField.value}
                    defaultValue={props.config.defaultvalue}
                    placeholder={props.config.placeholder}
                />
                {props.config.characterlimit ? (
                    <p className={'eve-form__charlimit'}>
                        {props.numCharsRemaining} {props.resources.charactersRemaining}
                    </p>
                ) : (
                    <></>
                )}
                {props.registeredField.errors.map((err, idx) => (
                    <div className={'eve-form__error'} key={`${idx}-${err}`}>
                        {err}
                    </div>
                ))}
            </>
        );
    } else {
        return (
            <>
                <label className='eve-form__label' htmlFor={props.config.name}>
                    {props.config.friendlyName}
                </label>
                <input
                    type='text'
                    id={props.config.name}
                    className={'eve-form__text-input'}
                    name={props.config.name}
                    value={props.registeredField.value}
                    placeholder={props.config.placeholder}
                    defaultValue={props.config.defaultvalue}
                    maxLength={props.config.characterlimit}
                    onChange={props.handleChange}
                />
                {props.config.characterlimit ? (
                    <p className={'eve-form__charlimit'}>
                        {props.numCharsRemaining} {props.resources.charactersRemaining}
                    </p>
                ) : (
                    <></>
                )}
                {props.registeredField.errors.map((err, idx) => (
                    <div className={'eve-form__error'} key={`${idx}-${err}`}>
                        {err}
                    </div>
                ))}
            </>
        );
    }
};
